// extracted by mini-css-extract-plugin
export default {"cls1":"ProfilePdfPackCard-cls1_skR","cls2":"ProfilePdfPackCard-cls2_z7H ProfilePdfPackCard-cls1_skR"};